import { z } from 'zod';
import { randomNumber } from '../../utils';
import { IAssetTypeId } from './IAssetType';
import {
  BankAccountAssetSchema,
  getEmptyBankAccountAsset,
} from './IBankAccountAsset';
import { CashAssetSchema, getEmptyCashAsset } from './ICashAsset';
import { DepotAssetSchema, getEmptyDepotAsset } from './IDepotAsset';
import { getEmptyLoanAsset, LoanAssetSchema } from './ILoanAsset';
import { getEmptyMortgageAsset, MortgageAssetSchema } from './IMortgageAsset';
import { getEmptyOtherAsset, OtherAssetSchema } from './IOtherAsset';
import { RealEstateAssetSchema } from './IRealEstateAsset';

export const AssetSchema = z.discriminatedUnion('idAssetType', [
  RealEstateAssetSchema,
  BankAccountAssetSchema,
  CashAssetSchema,
  DepotAssetSchema,
  LoanAssetSchema,
  MortgageAssetSchema,
  OtherAssetSchema,
]);

export type IAsset = z.infer<typeof AssetSchema>;

export function getEmptyTestamentAsset(assetTypeId: number): IAsset {
  const newIdAsset = -randomNumber();

  switch (assetTypeId) {
    // case 1:
    //   return createEmptyRealEstate(newIdAsset);
    case IAssetTypeId.BankAccount:
      return getEmptyBankAccountAsset(newIdAsset);
    case IAssetTypeId.Cash:
      return getEmptyCashAsset(newIdAsset);
    case IAssetTypeId.Depot:
      return getEmptyDepotAsset(newIdAsset);
    case IAssetTypeId.Loan:
      return getEmptyLoanAsset(newIdAsset);
    case IAssetTypeId.Mortgage:
      return getEmptyMortgageAsset(newIdAsset);
    case IAssetTypeId.Other:
      return getEmptyOtherAsset(newIdAsset);
    default:
      throw new Error('Unknown asset type id');
  }
}

export function updateOrCreateAsset(
  assetArray: IAsset[],
  asset: IAsset
): IAsset[] {
  const index = assetArray.findIndex(a => a.idAsset === asset.idAsset);
  if (index !== -1) {
    const updatedAssets = [...assetArray];
    updatedAssets[index] = asset;
    return updatedAssets;
  } else {
    return [...assetArray, asset];
  }
}
